import React from 'react';
import EquityBarChart from './EquityBarChart';

const ResultDashboard = ({
  markers,
  resetMarkers,
  handleRemoveMarker,
  totalRidershipCurrent,
  totalPredValue,
  currentStationsAccessbilitySum,
  accessibilitySum,
  equityData,
  handleSaveMarkers,
  handleGeoJSONUpload,
}) => {

  const ridershippercent = (totalPredValue * 52) / (totalRidershipCurrent * 52 + totalPredValue * 52) * 100;
  const accessibilitypercent = (accessibilitySum) / (currentStationsAccessbilitySum * 1 + accessibilitySum * 1) * 100;

    
  return (
    <div className="result-dashboard">
        <div className="station-list-container">
          <div>
            <p className="dashboard-title">
              New Stations
              <button onClick={resetMarkers} className="reset-button">
                Reset
              </button>
            </p>
          </div>
          <div className="station-list">
            {markers.map((marker, index) => (
              <div key={index} className="station">
                <div className="station-name">{`Station${index + 1}`}</div>
                <button className="delete-button" onClick={() => handleRemoveMarker(index)}>
                  delete
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="evaluate-container">
          <div className="result-title-popup">
            <p className="result-title">Ridership &#9432;</p>
            <div className="popup-content">
              <p>Total annual Indego bike trips. Predictions are limited to one new station per grid cell.</p>
            </div>
          </div>
          <div className="result-content-container">
            <p className="result-content">{(totalRidershipCurrent * 52 + totalPredValue * 52).toLocaleString()}</p>
            <p className="result-content red">(▲{(totalPredValue * 52).toLocaleString()} / {ridershippercent.toFixed(2)}%)</p>
          </div>
          <div className="result-title-popup">
            <p className="result-title">Accessibility &#9432;</p>
            <div className="popup-content" style={{ top: '-45%' }}>
              <p>Total population with access to at least 1 Indego bike station within a 5 minute walk.</p>
            </div>
          </div>
          <div className="result-content-container">
            <p className="result-content">{(currentStationsAccessbilitySum * 1 + accessibilitySum * 1).toLocaleString()}</p>
            <p className="result-content red">(▲{(accessibilitySum).toLocaleString()} / {accessibilitypercent.toFixed(0)}%)</p>
          </div>
          <div className="result-title-popup">
            <p className="result-title">Equity &#9432;</p>
            <div className="popup-content" style={{ top: '-45%' }}>
              <p>The racial makeup of those living within Indego's accessible service area.</p>
            </div>
          </div>

          <div className="result-content-container-equity">
            {/* {equityData.map(({ label, diff, cssClass, text, percentage }, index) => (
              <div key={index} className="equity-lines">
                <p className="result-content">
                  {label}: {percentage}%
                </p>
                <p className={`result-content ${cssClass}`}> ({text}{Math.abs(diff)}%) </p>
              </div>
            ))} */}
            <div>
              <div className='equity-label'>
                <div className='equity-label-inside'>
                  <div className='large' style={{ color: '#BDC2C2' }}> ■ </div>
                  <div className='popup'>
                    <div style={{ color: '#BDC2C2' }}> Current Indego Racial Makeup</div>
                  </div>
                </div>
                <div className='equity-label-inside'>
                  <div className='large' style={{ color: '#0078A8' }}> ■ </div>
                  <div className='popup'>
                    <div style={{ color: '#0078A8' }}> New Indego Racial Makeup</div>
                  </div>
                </div>
                <div className='equity-label-inside'>
                  <div style={{ color: 'rgb(252, 123, 123)' }} className='large'> ▬ </div>
                  <div style={{ color: 'rgb(252, 123, 123)' }}> Philly's Racial Makeup </div>
                </div>
              </div>
              <EquityBarChart equityData={equityData} />
            </div>
          </div>

          <div className="download-container">
            <div className="button-popup">
              <button onClick={handleSaveMarkers} className="download-button">
                Download &#9432;
              </button>
              <div className="popup-content">
                <p>Download your newly added stations as Geojson!</p>
              </div>
            </div>
            
            <div className="import-popup">
              <label className="import-button">
                Import &#9432;
                <input type="file" accept=".geojson" onChange={handleGeoJSONUpload} />
              </label>
              <div className="popup-content">
                <p>Try uploading a Geojson file you've already downloaded!</p>
              </div>
            </div>
          </div>

        </div>
    </div>
  );
};

export default ResultDashboard;
